import { render, staticRenderFns } from "./FloatingHorizontalScrollbar.vue?vue&type=template&id=12577cd6&scoped=true"
import script from "./FloatingHorizontalScrollbar.vue?vue&type=script&lang=js"
export * from "./FloatingHorizontalScrollbar.vue?vue&type=script&lang=js"
import style0 from "./FloatingHorizontalScrollbar.vue?vue&type=style&index=0&id=12577cd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12577cd6",
  null
  
)

export default component.exports